// Тексты интерфейса. Пока только русский; при локализации — заменить на словарь по языку.
import type { FinishReasonDto, KickOutcomeDto, ShotQualityDto } from '@penalty-cup/shared';

/** Название раунда по размеру сетки: последний — финал, перед ним — полуфинал, ещё раньше — 1/4. */
export function roundTitle(round: number, size: number): string {
  if (size === 2) return 'Дуэль';
  const fromEnd = Math.log2(size) - round;
  return fromEnd === 0
    ? 'Финал'
    : fromEnd === 1
      ? 'Полуфинал'
      : fromEnd === 2
        ? '1/4 финала'
        : `Раунд ${round}`;
}

export const isFinalRound = (round: number, size: number) => round === Math.log2(size);

/** Место по раунду выбывания: в сетке на 8 выбывший в 1/4 — «5–8 место», в финале — «2 место». */
export function placeTitle(eliminatedIn: number, size: number): string {
  const better = size >> eliminatedIn; // сколько игроков прошли дальше
  return better === 1 ? '2 место' : `${better + 1}–${better * 2} место`;
}

/** Ошибки действий с турнирами (коды сервера) — для игрока. */
export const TOURNAMENT_ERRORS: Record<string, string> = {
  already_in_tournament: 'Сначала доиграйте текущий турнир',
  invite_not_found: 'Приглашение не найдено — попросите друга прислать ссылку ещё раз',
  invite_expired: 'Приглашение устарело или турнир уже начался',
  tournament_full: 'Все места уже заняты',
  not_enough_players: 'Нужен хотя бы один друг — пригласите его по ссылке',
  not_owner: 'Начать может только создатель',
};

export const OUTCOME_TITLE: Record<KickOutcomeDto, string> = {
  GOAL: 'ГОЛ!',
  SAVE: 'СЕЙВ!',
  MISS: 'МИМО',
  POST: 'ШТАНГА!',
};

export const QUALITY_LABEL: Record<ShotQualityDto, string> = {
  PERFECT: 'Идеальный удар',
  GOOD: 'Хороший удар',
  BAD: 'Неточный удар',
};

export const FINISH_NOTE: Record<FinishReasonDto, string> = {
  SCORE: '',
  SUDDEN_DEATH: 'в серии до первой разницы',
  FORFEIT: 'соперник покинул матч',
  AFK: 'техническое поражение за пропуск ходов',
};

export function pluralRu(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

export const SLOT_TITLES: Record<string, string> = {
  ball: '⚽ Мяч',
  stadium: '🏟 Стадион',
  frame: '🖼 Рамка',
  celebration: '🎉 Гол',
  kit: '👕 Форма',
};

export const SHOP_ERRORS: Record<string, string> = {
  not_enough_coins: 'Не хватает монет — сыграйте ещё турнир',
  already_owned: 'Этот предмет уже ваш',
  not_owned: 'Сначала купите предмет',
  stars_disabled: 'Оплата звёздами пока недоступна',
};
